import { InfoAlert } from "./styles";
import closeIcon from "./imgs/close-icon.svg";
import headerImg from "./imgs/program-banner.png";
import Schedule from "./Schedule";

const Program = ({ onClose, scheduleDays = [], scheduleError }) => {
  return (
    <InfoAlert>
      <div className="inner-container">
        <div className="img-container">
          <img src={headerImg} alt="header" />
          <h2>{"Program"}</h2>
        </div>
        <div className="close-button" onClick={onClose}>
          <img src={closeIcon} alt="close" />
        </div>
        <div className="scroll-view">
          <Schedule days={scheduleDays} error={scheduleError} />
        </div>
      </div>
    </InfoAlert>
  );
};

export default Program;
